import { ComparisonChartsPage, ComparisonChartsPageConfig } from '@app/components/page/ComparisonChartsPage'
import { BackofficeApiActions } from '@lib/Core/API/BackofficeApiActions'
import React from 'react'

const ComparisonChartsPageConfig: ComparisonChartsPageConfig = {
  tableName: 'custom.ingredient_analysis_table',
  getFiltersActionName: BackofficeApiActions.GetIngredientInsightsFilters,
  getDataActionName: BackofficeApiActions.GetIngredientInsightsData,
  pageTitle: 'Compare ingredients',
  pageDescription: 'Apply filters and explore results to discover new opportunities.',
}

const IngredientAnalysisComparison: React.FunctionComponent = () => {
  return <ComparisonChartsPage {...ComparisonChartsPageConfig}></ComparisonChartsPage>
}

export { IngredientAnalysisComparison }
